import { createReducer } from '@reduxjs/toolkit'
import { RtmGroup } from 'interfaces/api/rtmGroups.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createRtmGroup,
  getAllRtmGroups,
  removeRtmGroup,
  setRtmGroupValidationErrors,
  setSingleRtmGroup,
  updateRtmGroup,
} from './actions'

interface RtmGroupsState {
  list: {
    loading: boolean
    items: RtmGroup[]
  }
  single: {
    loading: boolean
    item: RtmGroup | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: RtmGroupsState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const rtmGroupsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllRtmGroups.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllRtmGroups.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllRtmGroups.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setRtmGroupValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSingleRtmGroup], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createRtmGroup.pending, removeRtmGroup.pending, updateRtmGroup.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createRtmGroup.rejected, removeRtmGroup.rejected, updateRtmGroup.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createRtmGroup.fulfilled, removeRtmGroup.fulfilled, updateRtmGroup.fulfilled], (state) => {
      state.single.loading = false
    })
})
